function toJson(datas) {
  let firstRow = datas.slice(0, 1)[0]
  let keys = getKey(firstRow)
  
  return getResult(datas.slice(1))
  
  function getKey(row) {
    return _.map(row, key => key.trim().toLowerCase())
  }
  
  function getResult(rows) {
    return _.chain(rows)
      .reduce((result, row) => {
        row = _.map(row, value => value.trim())
        result.push(_.object(keys, row))
        return result
      }, [])
      .map((object, index) => {
        return _.omit(object, '')
      })
      .value()
  }
}

export { toJson }


// WEBPACK FOOTER //
// ./assets/util/toJson.js